module.exports = __webpack_public_path__ + "assets/images/spoke-logo-ddd2655333da7ed72e1ba4f7231de49e.png";